import React from 'react';
import {
  IonToolbar, IonButtons, IonTitle, IonHeader, IonCard, IonAlert,
  IonTextarea, IonContent, IonIcon, IonButton, IonCardContent,
} from '@ionic/react';
import { save, arrowBack} from 'ionicons/icons'

type Props = {
  value: string;
  name: string;
  closeNotes: () => void;
  notesHandler: (notes: string) => void;
};

class Notes extends React.Component<Props> {
  state = {
    notes: '',
    showAlert: false,
    alertMessage: 'Notes must be longer than 20 characters long.',
  }
  constructor(props: Props) {
    super(props);
    const { value } = this.props;
    this.state = {
      ...this.state,
      notes: value,
    };
  }
  dismissAlert() {
    this.setState({
      ...this.state,
      showAlert: false,
    });
  }
  handleChange = (e: CustomEvent) => {
    this.setState({
      ...this.state,
      notes: e.detail.value,
    });
  }

  updateNote = () => {
    if (this.state.notes.length < 20) {
      this.setState({
        ...this.state,
        showAlert: true,
      })
      return;
    }
    this.props.notesHandler(this.state.notes);
    this.props.closeNotes();
  }
  
  render() {
    return (
      <>
        <IonAlert
          isOpen={this.state.showAlert}
          onDidDismiss={() => this.dismissAlert()}
          header={'Alert'}
          message={this.state.alertMessage}
          buttons={['OK']}
        />
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={this.props.closeNotes}><IonIcon icon={arrowBack} slot="icon-only" /></IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={this.updateNote} strong><IonIcon icon={save} slot="icon-only" /></IonButton>
            </IonButtons>
            <IonTitle>{this.props.name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonCard>
            <IonCardContent>
          <IonTitle >Notes</IonTitle>
          <IonTextarea rows={20} cols={20} value={this.state.notes} onIonChange={this.handleChange} placeholder="Add your notes here" />
          </IonCardContent>
          </IonCard>
        </IonContent>
      </>
    )
  }
};

export default Notes;
